import { useContext } from "react";
import { BackDroptContext } from "contexts/BackDropContext";

export default function useBackDrop() {
  return useContext(BackDroptContext);
}
